/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type PropertyApiResourceCleanStatus = typeof PropertyApiResourceCleanStatus[keyof typeof PropertyApiResourceCleanStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyApiResourceCleanStatus = {
  clean: 'clean',
  dirty: 'dirty',
} as const;
